// ServicePage.jsx
import { useParams, Link } from "react-router-dom";
import servicesData from "./servicesData";

export default function ServicePage() {
  const { serviceId } = useParams();
  const service = servicesData[serviceId];

  if (!service) return <div className="p-10 text-white">Service not found.</div>;

  // Split features into two halves
  const mid = Math.ceil(service.features.length / 2);
  const firstHalf = service.features.slice(0, mid);
  const secondHalf = service.features.slice(mid);

  return (
    <div className="min-h-screen bg-[#0f111a] text-white p-10 flex flex-col items-center">
      <div className="flex flex-col items-center bg-[#1a1f2b]/80 p-10 rounded-2xl border border-gray-800 w-full max-w-5xl backdrop-blur-sm">

        {/* Service Banner */}
        {service.banner && (
          <img
            src={service.banner}
            alt={service.title}
            className="w-full h-64 object-cover rounded-2xl mb-8"
          />
        )}

        {/* Icon */}
        <div className="mb-6 w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-tr from-[#00fff7] to-[#0077ff]">
          {service.icon}
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-center">
          {service.title}
        </h1>

        {/* Description */}
        <p className="text-gray-300 text-lg md:text-xl text-center mb-8">
          {service.desc}
        </p>

        {/* Features Section */}
        {service.features && (
          <div className="w-full mt-6">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-[#00fff7] text-center">
              Features
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300">
              <ul className="list-disc list-inside space-y-2">
                {firstHalf.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <ul className="list-disc list-inside space-y-2">
                {secondHalf.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            {/* Additional Images */}
            {service.images && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                {service.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${service.title} ${index + 1}`}
                    className="w-full rounded-xl border border-gray-700"
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* Back Button */}
        <Link
          to="/#services"
          className="mt-10 py-2.5 px-6 rounded-xl bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-black font-semibold shadow-md hover:opacity-90 transition"
        >
          ← Back to Services
        </Link>
      </div>
    </div>
  );
}
